/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Sellerstooltip2Inputs */

const id_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah total penjual unik yang menyediakan penawaran`)
};

const ms_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah penjual unik yang menyediakan tawaran`)
};

const da_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet antal unikke sælgere der leverer tilbud`)
};

const de_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der Verkäufer, die Angebote bereitstellen`)
};

const en_us2_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique sellers providing offers`)
};

const es_es2_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de vendedores únicos que proveen ofertas`)
};

const es_mx2_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de vendedores únicos que proveen ofertas`)
};

const fil_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang bilang ng mga natatanging nagbebenta na nagbibigay ng mga offer`)
};

const fr_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total de vendeurs uniques fournissant des offres`)
};

const it_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero totale di venditori unici che forniscono offerte`)
};

const hu_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ajánlatokat biztosító egyedi eladók teljes száma`)
};

const nl_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal aantal unieke verkopers die aanbiedingen leveren`)
};

const no_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antall unike selgere som leverer tilbud`)
};

const pl_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba unikalnych sprzedawców dostarczających oferty`)
};

const pt_br2_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique sellers providing offers`)
};

const pt_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de vendedores únicos a fornecer ofertas`)
};

const ro_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numărul total de vânzători unici care furnizează oferte`)
};

const fi_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksia tarjoavien ainutlaatuisten myyjien kokonaismäärä`)
};

const sv_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal unika säljare som tillhandahåller erbjudanden`)
};

const vi_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số người bán độc nhất cung cấp ưu đãi`)
};

const tr_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif sağlayan benzersiz satıcı sayısı`)
};

const cs_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkový počet unikátních prodejců poskytujících nabídky`)
};

const bg_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ брой уникални продавачи, предлагащи оферти`)
};

const ru_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее количество уникальных продавцов, проводивших раздачи`)
};

const uk_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна кількість унікальних продавців пропозицій`)
};

const ar_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي عدد البائعين الفريدين الذين يقدمون عروضًا`)
};

const hi_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अद्वितीय विक्रेताओं की कुल संख्या`)
};

const th_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนผู้ขายที่ไม่ซ้ำกันทั้งหมดที่ให้ข้อเสนอ`)
};

const ja_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーを提供するユニークな販売元の総数`)
};

const zh_cn2_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique sellers providing offers`)
};

const zh_hant1_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique sellers providing offers`)
};

const ko_components_giveawaystats_sellerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Sellerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique sellers providing offers`)
};

/**
* | output |
* | --- |
* | "Total number of unique sellers providing offers" |
*
* @param {Components_Giveawaystats_Sellerstooltip2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_sellerstooltip2 = /** @type {((inputs?: Components_Giveawaystats_Sellerstooltip2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Sellerstooltip2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "ms") return ms_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "da") return da_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "de") return de_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "fil") return fil_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "fr") return fr_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "it") return it_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "hu") return hu_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "nl") return nl_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "no") return no_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "pl") return pl_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "pt") return pt_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "ro") return ro_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "fi") return fi_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "sv") return sv_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "vi") return vi_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "tr") return tr_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "cs") return cs_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "bg") return bg_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "ru") return ru_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "uk") return uk_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "ar") return ar_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "hi") return hi_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "th") return th_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "ja") return ja_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_sellerstooltip2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_sellerstooltip2(inputs)
	return ko_components_giveawaystats_sellerstooltip2(inputs)
});
export { components_giveawaystats_sellerstooltip2 as "components.giveawayStats.sellersTooltip" }